import React, { useContext, useRef, useState } from 'react';
import { getAxiosTokenInstance } from '../../utils/axiosInstance';
import { useQuery } from 'react-query';
import { FirebaseContext } from '../../context/FirebaseContext';
import { useDropDowns } from '../../NecttosComp/APICaller/queryHooks';
import { getIssuedBook, getMembers } from '../../NecttosComp/APICaller/ApiServices';
import noPhotoAvailable from '../../static/images/library/noPhotoAvailable.png';
import noBookImageFount from '../../static/images/library/noBookImageFount.png';
import moment from 'moment';
import SearchableBookInput from '../../myComp/SearchableBookInput';
import { Body, Header, Main } from '../../NecttosComp/Layout/Layout';
import Input from '../../NecttosComp/Input/Input';
import Button from '../../NecttosComp/Button/Button';
import SearchableUserInputPhoto from '../../myComp/SearchableUserInputPhoto';
import { Table, Thead, Th, Tbody, Tr, Td } from '../../NecttosComp/Table/Table';
import Instruction from '../../Documentation/Instruction';

export const IssueBook = ({ onClose }) => {
	const [loading, setLoading] = useState(false);

	const [state, setState] = React.useState({
		filterValue: '',
		page: 0,
	});

	const { collegeId, collegeList } = useContext(FirebaseContext);
	const componentRef = useRef();
	const selectedCollege = collegeList?.find((x) => x.collegeId === collegeId);

	const { data: membersList, isLoading: memberShort, refetch: memberRefetch } = useQuery(['membersListWW', state?._id], getMembers(state.collegeId, state?.searchMember, state?._id), { keepPreviousData: false });
	const { data: issuedBook, refetch: issuedBookRefetch } = useQuery(['issuedDataBooks'], getIssuedBook({ collegeId, state, setLoading }));
	const { data: dropDown } = useDropDowns('library');

	let memberData = membersList?.membersList || {};
	let issuedData = issuedBook?.issuedData || {};

	const UpdateBookStatus = async () => {
		try {
			setLoading(true);
			let data = {
				data: state.data,
				collegeId,
				userId: memberData?.userId,
				action: 'taken',
				status: 'taken',
			};
			const instance = await getAxiosTokenInstance();
			const resp = await instance.post('/college/library/takeBook', data);
			setState({
				admisionNo: '',
			});
			setLoading(false);
			issuedBookRefetch();
			return resp.data;
		} catch (err) {
			return new Error('Book not available');
		}
	};

	let limit = !memberData?.limit ? 0 : memberData?.limit;

	let booksCount = Array(limit).fill(1);

	const selectedBookView = async () => {
		let booksCount = Array(10).fill(1);
		const data = [];

		booksCount?.forEach((_, i) => {
			if (state[`keyData${i}bookStocksId`]) {
				data.push({
					bookId: state[`keyData${i}bookId`],
					bookStocksId: state[`keyData${i}bookStocksId`],
					nameOfBook: state[`keyData${i}nameOfBook`],
					accessionNumber: state[`keyData${i}accessionNumber`],
					callNo: state[`keyData${i}callNo`],
					image: state[`keyData${i}image`],
					bookDetails: state[`keyData${i}bookDetails`],
				});
			}
		});

		setState({ ...state, data });
	};
	const backReset = async () => {
		setState({ ...state, data: [] });
	};
	const total = parseInt(issuedData?.total?.[0]?.total || 0);
	return (
		<Main width='100%' height='100%' title='Issue Register'>
			<Header className='flex flex-col lg:flex-row justify-between gap-4 flex-wrap'>
				<div className='flex flex-wrap items-center gap-3'>
					<Button
						type='save'
						disabled={parseInt(state.page) < 1}
						onClick={() => {
							setState({ ...state, page: parseInt(state.page) - 1 });
						}}>
						Prev
					</Button>

					<Input width='80px' returnKey='page' fieldName='Pages' state={state} setState={setState} type='text' />

					<Button
						type='save'
						disabled={parseInt(state.page) * 30 >= total - 30}
						onClick={() => {
							setState({ ...state, page: parseInt(state.page) + 1 });
						}}>
						Next
					</Button>

					<div className='inline-flex h-[40px] items-center justify-center px-4 bg-gray-100 dark:bg-gray-700 rounded-lg shadow text-sm font-medium text-gray-800 dark:text-white whitespace-nowrap'>
						<span>
							Showing <strong>{parseInt(state.page) * 30 + 1}</strong> - <strong>{parseInt(state.page) * 30 + 30}</strong> of <strong>{issuedData?.total?.[0]?.total || 0}</strong>
						</span>
					</div>

					<Input width='200px' fieldName='Filter Type' options={typeof dropDown?.['shortItems'] === 'array' ? dropDown?.['shortItems'] : []} returnKey='filterType' state={state} setState={setState} type='drop' />
					<Input width='230px' fieldName='Languages' options={dropDown?.[state?.filterType] || []} returnKey='filterValue' state={state} setState={setState} type='drop' />
					<Input width='200px' returnKey='startDate' fieldName='Start Date' state={state} setState={setState} type='date' />
					<Input width='200px' returnKey='endDate' fieldName='End Date' state={state} setState={setState} type='date' />
				</div>

				<div className='flex flex-wrap items-center gap-2'>
					<Button type='fetch' onClick={issuedBookRefetch}>
						Load
					</Button>
					<Button type='print' tableRef={componentRef.current}>
						Print
					</Button>
					<Instruction keyId={'issueBook'}/>
					<Button type='close' onClick={onClose}>
						Close
					</Button>
				</div>
			</Header>

			<SearchableUserInputPhoto primoryKey={'admisionNo'} secondaryKey={'name'} tertiaryKey={'phoneNumber'} collection={'users'} stateData={state} setStateData={setState} titleData={'Search Admission No or Name'} style={state._id ? { width: '800px' } : { width: '60%' }} />
			{state?.admisionNo && state?.admisionNo === memberData?.name && state?._id === memberData?.userId ? (
				<Body>
					<div className='flex flex-col lg:flex-row gap-6 p-4 w-full bg-white rounded-lg mt-2'>
						<div className='w-full lg:w-1/2 flex flex-col gap-4'>
							<div className='flex items-center gap-4 p-4 shadow-lg rounded-2xl bg-white dark:bg-gray-800 dark:text-white'>
								<div className='flex-shrink-0'>
									<img src={memberData?.photoURL || noPhotoAvailable} alt='Member DP' className='w-24 h-24 rounded-full object-cover border-2 border-gray-300 dark:border-gray-600' />
								</div>
								<div className='flex flex-col gap-1'>
									<h5 className='text-xl font-bold'>{memberData?.name}</h5>
									<p>{memberData?.className}</p>
									<p>Mn: {memberData?.admisionNo}</p>
									<p>Book in Hand: {memberData?.bookInHand}</p>
									<p>Limit: {memberData?.limit}</p>
								</div>
							</div>

							<div className='h-[350px] overflow-auto shadow-lg rounded-2xl bg-white dark:bg-gray-800 dark:text-white p-3'>
								<div className='grid grid-cols-1 sm:grid-cols-2 gap-4'>
									{memberData?.booksInHand?.map((item, i) => (
										<div key={i} className='p-4 rounded-2xl bg-white dark:bg-gray-800 shadow-md flex flex-col gap-3 transition duration-300 hover:shadow-xl'>
											<div className='flex items-center gap-4'>
												<img src={item.photoURL || noBookImageFount} alt='Book' className='w-16 h-16 rounded-lg object-cover border border-gray-300 dark:border-gray-600' />
												<div className='flex flex-col gap-1'>
													<h2 className='text-md font-bold text-gray-800 dark:text-white'>{item.accessionNumber}</h2>
													<h3 className='text-sm text-gray-600 dark:text-gray-400'>{item.callNo}</h3>
												</div>
											</div>
											<h4 className='text-sm font-medium text-gray-700 dark:text-gray-200' title={item.nameOfBook}>
												{item.nameOfBook.length > 60 ? `${item.nameOfBook.slice(0, 26)} ... ${item.nameOfBook.slice(-26)}` : item.nameOfBook}
											</h4>
										</div>
									))}
								</div>
							</div>
						</div>

						<div className='w-full lg:w-1/2 flex flex-col gap-4'>
							{state?.data?.length > 0 ? (
								<div className='h-[600px] overflow-auto shadow-lg rounded-2xl bg-white dark:bg-gray-800 dark:text-white p-3'>
									<div className='grid grid-cols-1 sm:grid-cols-2 gap-4'>
										{state?.data?.map((item, i) => (
											<div key={i} className='p-4 rounded-2xl bg-white dark:bg-gray-800 shadow-md flex flex-col gap-3 transition duration-300 hover:shadow-xl'>
												<div className='flex items-center gap-4'>
													<img src={item.photoURL || noBookImageFount} alt='Book' className='w-16 h-16 rounded-lg object-cover border border-gray-300 dark:border-gray-600' />
													<div className='flex flex-col gap-1'>
														<h2 className='text-md font-bold text-gray-800 dark:text-white'>{item.accessionNumber}</h2>
														<h3 className='text-sm text-gray-600 dark:text-gray-400'>{item.callNo}</h3>
													</div>
												</div>
												<h4 className='text-sm font-medium text-gray-700 dark:text-gray-200' title={item.nameOfBook}>
													{item.nameOfBook.length > 60 ? `${item.nameOfBook.slice(0, 26)} ... ${item.nameOfBook.slice(-26)}` : item.nameOfBook}
												</h4>
											</div>
										))}
									</div>
								</div>
							) : (
								booksCount.map((_, i) => (
									<div key={i} className='flex flex-col items-start sm:flex-row gap-2 p-0 m-0 bg-gray-100 rounded-lg'>
										<div className='w-full sm:w-3/4'>
											<SearchableBookInput filter='taken' stateData={state} setStateData={setState} keyData={`keyData${i}`} titleData={`Search Book ${i + 1}`} />
										</div>
										<div className='w-full sm:w-1/4'>
											<Input width='180px' returnKey={`keyData${i}bookDetails`} fieldName='Remarks' state={state} setState={setState} type='text' />
										</div>
										<Button
											type='close'
											onClick={() => {
												setState({
													...state,
													[`keyData${i}`]: '',
													[`keyData${i}bookId`]: '',
													[`keyData${i}bookStocksId`]: '',
													[`keyData${i}imageUrl`]: '',
													[`keyData${i}callNo`]: '',
													[`keyData${i}accessionNumber`]: '',
													[`keyData${i}nameOfBook`]: '',
												});
											}}>
											Clear
										</Button>
									</div>
								))
							)}

							<div className='mt-4 flex flex-col gap-3'>
								{state?.data?.length > 0 && (
									<Button type='close' onClick={backReset}>
										Back
									</Button>
								)}
								{limit > 0 && state?.data?.length === 0 && (
									<Button type='save' onClick={selectedBookView}>
										Next
									</Button>
								)}
								{state?.data?.length > 0 && (
									<Button type='submit' onClick={UpdateBookStatus}>
										Issue {state?.data?.length} Books
									</Button>
								)}
								{limit < 1 && (
									<div className='text-sm text-red-600 dark:text-red-400 mt-2'>
										<p>Oops! The limit is over, please return some books and get new books...</p>
									</div>
								)}
							</div>
						</div>
					</div>
				</Body>
			) : (
				<Body>
					<div ref={componentRef} className='printable w-full p-4 overflow-x-auto'>
						<div className='min-w-[950px] w-full flex flex-col gap-4 rounded-2xl p-4 bg-slate-100 dark:bg-neutral-700 text-black'>
							<div className='flex items-center gap-4'>
								<img src={selectedCollege?.logo} alt='College Logo' className='w-20 h-20 object-contain' />
								<div className='flex flex-col items-center w-full text-center'>
									<span className='text-3xl font-extrabold text-gray-800 dark:text-slate-100'>{selectedCollege?.collegeShortName}</span>
									<p className='text-2xl font-bold text-gray-800 dark:text-slate-100'>{selectedCollege?.accreditedGrade}</p>
									<p className='text-sm font-semibold text-gray-800 dark:text-slate-100'>
										{selectedCollege?.address}, Phone: {selectedCollege?.phoneNumber}
									</p>
								</div>
							</div>

							<h5 className='text-2xl font-bold text-left text-slate-800 dark:text-slate-100'>Issue Register</h5>

							<Table width='100%' innerWidth={['7%', '10%', '35%', '13%', '10%', '10%', '10%', '15%', '15%']}>
								<Thead>
									<Tr>
										<Th position={0} textAlign='center'>
											Sn
										</Th>
										<Th position={1} textAlign='center'>
											Acc No
										</Th>
										<Th position={2}>Title</Th>
										<Th position={3}>Author</Th>
										<Th position={4} textAlign='center'>
											Time
										</Th>
										<Th position={5} textAlign='center'>
											Mn No
										</Th>
										<Th position={6} textAlign='center'>
											Class/Dept.
										</Th>
										<Th position={7}>Mn Name</Th>
										<Th position={8}>Issued By</Th>
									</Tr>
								</Thead>
								<Tbody height='60vh'>
									{issuedData?.data?.map((item, index) => (
										<Tr key={index} index={index}>
											<Td position={0} index={index} textAlign='center'>
												{item.sn}
											</Td>
											<Td position={1} index={index} textAlign='center'>
												{item.accessionNumber}
											</Td>
											<Td position={2} index={index}>
												{item.title}
											</Td>
											<Td position={3} index={index}>
												{item.author}
											</Td>
											<Td position={4} index={index} textAlign='center'>
												{moment(item?.tookOn).format('DD MMM YYYY hh:mm A')}
											</Td>
											<Td position={5} index={index} textAlign='center'>
												{item.admisionNo}
											</Td>
											<Td position={6} index={index} textAlign='center'>
												{item.className}
											</Td>
											<Td position={7} index={index}>
												{item.issuedTo}
											</Td>
											<Td position={8} index={index}>
												{item.issuedBy}
											</Td>
										</Tr>
									))}
								</Tbody>
							</Table>

							{/* Footer */}
							<h5 className='mt-6 text-right text-xs font-medium'>Seal & Signature {moment(new Date()).format('DD MMM YYYY hh:mm A')}</h5>
						</div>
					</div>
				</Body>
			)}
		</Main>
	);
};
